import { CurrencyResponse } from '../types/api-responses/currency-response'
import { CurrencyModel } from '../types/models/currency.model'

export function currencyResolver(currency: CurrencyResponse): CurrencyModel
export function currencyResolver(currency: CurrencyResponse[]): CurrencyModel[]

export function currencyResolver(
  currency: CurrencyResponse | CurrencyResponse[],
): CurrencyModel | CurrencyModel[] {
  if (Array.isArray(currency)) {
    return currency.map(resolveCurrency)
  }
  return resolveCurrency(currency)
}

function resolveCurrency(currency: CurrencyResponse): CurrencyModel {
  return {
    id: currency.id,
    code: currency.code,
    isActive: currency.is_active === '1',
    name: currency.name,
    rate: currency.rate,
    symbol: currency.symbol,
  }
}
